import styled from 'styled-components'

export const Container = styled.div`
  .mobile {
    margin-top: 21px;
    padding: 0 1.5rem;
  }

  @media only screen and (min-width: 1090px) {
    .mobile {
      display: none;
    }
  }
`

export const Options = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;

  border: 1px solid #bababa;
  border-left: none;
  border-right: none;

  padding: 14px 24px;

  margin-top: 24px;

  @media only screen and (min-width: 800px) {
    width: 100%;
    border: 1px solid #bababa;
    border-radius: 8px;

    padding: 18px 34px;
  }
`

export const Wrapper = styled.div`
  display: flex;
  gap: 2px;
`

export const GenerateNotebook = styled.button`
  color: rgb(${({ theme }) => theme.primary.base});
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;

  padding: 0;

  border: none;
  background: none;

  transition: opacity 0.3s ease;

  :disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const PaginateWrapper = styled.div`
  display: none;
  /* padding-left: 10rem; */

  @media only screen and (min-width: 1090px) {
    display: flex;
  }
`

export const LettersUpDown = styled.div`
  display: grid;
  grid-template-columns: 50px 50px;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  width: 80px;
  height: 40px;
  border: 1px solid #bababa;
  border-radius: 3px;
  background: transparent;

  @media only screen and (min-width: 1090px) {
    display: flex;
    justify-content: center;
    align: center;
    margin-right: 23px;
    margin-left: 23px;
  }
`

export const LetterUp = styled.button`
  text-align: center;
  padding-left: 5px;
  font-size: 14px;
  width: 100%;
  height: 35px;
  color: #808080;
  background: transparent;
  border: none;
  border-right: 1px solid #bababa;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;

    &:hover {
      filter: brightness(0.9);
    }
  }

  @media only screen and (min-width: 1090px) {
    width: 95%;
  }
`

export const LetterDown = styled.button`
  padding-right: 1px;
  width: 90%;
  height: 35px;
  border: none;
  background: transparent;
  color: #808080;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;

    &:hover {
      filter: brightness(0.9);
    }
  }
`

export const Selects = styled.div`
  display: none;

  @media only screen and (min-width: 1090px) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;

    .text-dropdown {
      .text-dropdown--button-area {
        padding: 10px;
      }
    }
  }
`

export const KeyBoard = styled.div`
  display: none;

  @media only screen and (min-width: 1090px) {
    display: flex;
    cursor: pointer;
    padding-left: 1rem;
    padding-top: 5px;
  }
`

export const PaginationContainer = styled.div`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  display: flex;
  gap: 12px;

  button {
    border: none;
    background-color: transparent;

    border-radius: 2px;

    padding: 2px 5px;
    font-size: 14px;
    font-weight: 700;

    color: #808080;

    transition: none;

    &[data-active='true'] {
      color: rgb(249, 249, 249);
      background-color: ${({ theme }) => `rgb(${theme.primary.base})`};
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .page-button {
      background-color: green;
    }
  }
`
